
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface SignUpFieldsProps {
  schoolId: string;
  mobileNumber: string;
  role: "staff" | "teacher";
  onSchoolIdChange: (value: string) => void;
  onMobileNumberChange: (value: string) => void;
  onRoleChange: (value: "staff" | "teacher") => void;
  disabled?: boolean;
  schoolIdError?: string | null;
}

export const SignUpFields = ({
  schoolId,
  mobileNumber,
  role,
  onSchoolIdChange,
  onMobileNumberChange,
  onRoleChange,
  disabled,
  schoolIdError
}: SignUpFieldsProps) => {
  return (
    <>
      <div className="space-y-2 mt-5">
        <label htmlFor="schoolId" className="text-sm font-medium text-gray-700">
          ID Sekolah
        </label>
        <Input 
          id="schoolId" 
          type="text" 
          placeholder="ID Sekolah (Alfanumerik)" 
          value={schoolId} 
          onChange={e => onSchoolIdChange(e.target.value)} 
          pattern="^[a-zA-Z0-9]+$" 
          title="ID Sekolah hanya boleh berisi huruf dan angka" 
          disabled={disabled} 
          required 
          className={`border-gray-300 focus:border-green-500 focus:ring-green-500 ${schoolIdError ? 'border-red-500' : ''}`}
        />
        {schoolIdError && (
          <p className="text-sm text-red-500 mt-1">{schoolIdError}</p>
        )}
      </div>
      
      <div className="space-y-2">
        <label htmlFor="mobileNumber" className="text-sm font-medium text-gray-700">
          Nomor HP
        </label>
        <Input 
          id="mobileNumber" 
          type="tel" 
          placeholder="Nomor HP" 
          value={mobileNumber} 
          onChange={e => onMobileNumberChange(e.target.value)} 
          disabled={disabled} 
          className="border-gray-300 focus:border-green-500 focus:ring-green-500" 
        />
      </div>
      
      <div className="space-y-2">
        <label htmlFor="role" className="text-sm font-medium text-gray-700">
          Peran
        </label>
        <Select 
          value={role} 
          onValueChange={(value: "staff" | "teacher") => onRoleChange(value)} 
          disabled={disabled}
        >
          <SelectTrigger id="role" className="border-gray-300 focus:border-green-500 focus:ring-green-500 bg-white">
            <SelectValue placeholder="Pilih peran" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="staff">Staff</SelectItem>
            <SelectItem value="teacher">Guru</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </>
  );
};
